import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import "./index.css";
import { bindActionCreators } from "redux";
import { instance } from "../../../Actions/AxiosInstance";
import {
  ValidateAction,
  ValidateReqField,
  ValidateReqFields,
} from "../../../Utils/Validation";
import { updateAuthentication } from "../../../Actions/AuthenticationAction";
import ChangePasswordSucess from "./ChangePasswordSucess";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    overflow: "hidden",
    position: "relative",
    backgroundColor: theme.palette.background.paper,
  },
});

class ChangePassword extends React.Component {
  state = {
    fields: {
      oldpassword: "",
      newpassword: "",
    },
    reqFields: {
      oldpassword: "",
      newpassword: "",
    },
    errors: {},
    helperText: {},
    value: 0,
    showOldPassword: false,
    showNewPassword: false,
    showSucess: false,
    hostname: window.location.hostname,
    subdomain: null,
  };

  handleClickShowOldPassword = () => {
    this.setState((state) => ({ showOldPassword: !state.showOldPassword }));
  };

  handleClickShowNewPassword = () => {
    this.setState((state) => ({ showNewPassword: !state.showNewPassword }));
  };

  SetHelperTextFlag(field, e) {
    const { helperText } = this.state;
    helperText[field] = true;
    this.setState({ helperText });
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields });
    ValidateAction(this.state, field, type);
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  Validate() {
    let formIsValid = true;

    if (!ValidateReqFields(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  onRoute() {
    localStorage.clear();
    this.props.updateAuthentication("LOGIN_PENDING", null);
    // this.props.history.push(`/forgotpassword`)
    let subdomain = this.state.hostname.split(".");
    subdomain = subdomain[0];
    // if (subdomain != "accounts") {
    //     this.props.history.push(`/forgotpassword`);
    // } else {
    //     this.props.history.push(`/forgotpassword`);
    // }
    this.props.history.push(`/forgotpassword`);
  }

  OnFormSubmit() {
    if (!this.Validate()) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else {
      const data = {
        oldpassword: this.state.fields.oldpassword,
        newpassword: this.state.fields.newpassword,
      };
      const URL = `account/changepassword`;
      instance
        .post(URL, data)
        .then((result) => {
          this.setState({
            showSucess: true,
          });
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          // console.log(...result)
          // this.props.history.push(`/sucess/${this.state.subscriptionid}`);
        })
        .catch((error) => {
          const ErrorNo = error.response
            ? error.response.data.error.number
            : error.number;
          if (ErrorNo == "E1160") {
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              {
                variant: "warning",
                action: (
                  <Button
                    color="secondary"
                    size="small"
                    onClick={() => this.props.closeSnackbar()}
                  >
                    Dismiss
                  </Button>
                ),
                // onClickAction: () => { this.onRoute() }
                // onClickAction: () => {
                //     localStorage.clear();
                //     this.props.updateAuthentication('LOGIN_PENDING', null)
                //     this.props.history.push(`/forgotpassword`)
                // }
              },
            );
          } else {
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          }
        });
    }
  }

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    const sucess = this.state.showSucess;
    let model;
    if (sucess === false) {
      model = (
        <div>
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              <div className="update-pwd">
                <p className="form-input-label margin-top-0">
                  <FormattedMessage
                    id="LbExisitingPassword"
                    defaultMessage="Existing password"
                  />
                </p>
                <TextField
                  id="oldpassword"
                  // label={<FormattedMessage id="LbExisitingPwd" defaultMessage="existing password" />}
                  className={classNames(classes.textField, "width500")}
                  value={this.state.fields.oldpassword}
                  // placeholder="existing password"
                  variant="outlined"
                  type={this.state.showOldPassword ? "text" : "password"}
                  onFocus={this.SetHelperTextFlag.bind(this, "oldpassword")}
                  onChange={this.OnFieldChange.bind(
                    this,
                    "oldpassword",
                    "password",
                  )}
                  onBlur={this.ValidateField.bind(
                    this,
                    "oldpassword",
                    "password",
                  )}
                  error={!!this.state.errors.oldpassword}
                  inputProps={{ maxLength: 256 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="ShowPassword"
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowOldPassword}
                        >
                          {this.state.showOldPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {!!this.state.errors.oldpassword &&
                !this.state.helperText.oldpassword ? (
                  <p className="caption-error">
                    <FormattedMessage
                      id="ErExisitingPwd"
                      defaultMessage="Minimum 8 characters, please 🙏"
                    />
                  </p>
                ) : (
                  ""
                )}
                {this.state.helperText.oldpassword ? (
                  <p className="caption-helptest">
                    <FormattedMessage
                      id="HtExisitingPwd"
                      defaultMessage=" Do you remember your existingpassword? 🗝️"
                    />
                  </p>
                ) : (
                  ""
                )}
              </div>
            </Grid>
            <Grid item xs={12} md={12} sm={12} className="padding-top-30">
              <div className="update-pwd">
                <p className="form-input-label">
                  <FormattedMessage
                    id="LbNewPassword"
                    defaultMessage="New password"
                  />
                </p>
                <TextField
                  id="newpassword"
                  // label={<FormattedMessage id="LbNewPwd" defaultMessage="new password" />}
                  className={classNames(classes.textField, "width500")}
                  value={this.state.fields.newPassword}
                  // placeholder="new password"
                  variant="outlined"
                  type={this.state.showNewPassword ? "text" : "password"}
                  onFocus={this.SetHelperTextFlag.bind(this, "newpassword")}
                  onChange={this.OnFieldChange.bind(
                    this,
                    "newpassword",
                    "password",
                  )}
                  onBlur={this.ValidateField.bind(
                    this,
                    "newpassword",
                    "password",
                  )}
                  error={!!this.state.errors.newpassword}
                  inputProps={{ maxLength: 256 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="ShowPassword"
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowNewPassword}
                        >
                          {this.state.showNewPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {!!this.state.errors.newpassword &&
                !this.state.helperText.newpassword ? (
                  <p className="caption-error">
                    <FormattedMessage
                      id="ErNewPwd"
                      defaultMessage="Minimum 8 characters, please 🙏"
                    />
                  </p>
                ) : (
                  ""
                )}
                {this.state.helperText.newpassword ? (
                  <p className="caption-helptest">
                    <FormattedMessage
                      id="HtNewPwd"
                      defaultMessage=" Please Enter New Password 🗝️"
                    />
                  </p>
                ) : (
                  ""
                )}
              </div>
            </Grid>
            <Grid item xs={12} md={12} sm={12} className="padding-top-30">
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  className={classNames("leadloginbutton", "padding-top-100")}
                  onClick={this.OnFormSubmit.bind(this)}
                >
                  <FormattedMessage id="BtSubmit" defaultMessage="Submit" />
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      );
    } else {
      model = <ChangePasswordSucess className="width100" />;
    }
    return (
      <div>
        <Helmet>
          <title>{headersList.ChangePassword.header}</title>
        </Helmet>
        {model}
      </div>
    );
  }
}
ChangePassword.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateAuthentication: (data) => updateAuthentication(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(ChangePassword)));
